import { QUERY_KEYS } from '../../../../consts';
import { verifyMobileVerificationCodeService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const verifyMobileVerificationCodeAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.VERIFY_MOBILE_CODE,
  mutationFn: () => verifyMobileVerificationCodeService,
  retry: 0,
});
